<template>
  <div class="currentSubject">
    <div class="currentSubject_header">
      <div class="currentSubject_header_left" @click="$router.push({ path: '/currentList' })">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>
    </div>

    <div class="currentSubject_main">
      <div class="currentSubject_main_top">
        <p class="currentSubject_main_title">{{ title }}现状测试</p>
        <p>{{ brief }}</p>
      </div>

      <div class="currentSubject_main_bottom">
        <div class="currentSubject_main_test" v-for="(item, index) in data" :key="index">
          <p class="currentSubject_main_test_title">{{ item.question_name }}</p>
          <van-radio-group v-model="item.radio">
            <van-radio v-for="(answer, index) in item.option" :name="answer.score" :key="index">{{ answer.answer }}</van-radio>
          </van-radio-group>
        </div>

        <div v-if="state === 1" class="currentSubject_main_test">
          <p class="currentSubject_main_test_title">{{ data.length + 1 }}.{{ child === 1 ? '孩子' : '您' }}目前是否在服用哮喘药物，若有，是什么？（填空，非必填）</p>
          <van-cell-group>
            <van-field v-model="answer" maxlength="20" placeholder="哮喘药物" />
          </van-cell-group>
        </div>
      </div>

      <Btn :btnData="{text: '完成测试'}" @btnClick="getAddResult"></Btn>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import Btn from '@/components/Btn'
export default {
  name: 'currentSubject',
  data () {
    return {
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      did: this.$route.query.did,
      title: '',
      brief: '',
      data: [],
      dataForm: [],
      state: 0, // 判断是否显示填空题
      answer: ''
    }
  },
  methods: {
    getCurrentQuestionList () {
      let that = this
      this.util.get(this.api.current_question_list + '?cid=' + this.did, '', (success) => {
        that.data = success.question
        that.title = success.data.disease_name
        that.brief = success.data.disease_brief
        that.state = success.state.tag
        for (let i = 0; i < that.data.length; i++) {
          that.$set(that.data[i], 'radio', '')
        }
      })
    },
    getAddResult () {
      this.dataForm = []
      this.data.forEach((item, index) => {
        if (item.radio === '') {
          Toast('请完成所有题目后再提交')
        } else {
          this.dataForm.push({
            cid: this.$route.query.did,
            qid: item.id,
            score: item.radio
          })
        }
      })
      if (this.dataForm.length === this.data.length) {
        if (this.state === 1) {
          this.dataForm.push({cid: this.$route.query.did, qid: 5, answer: this.answer})
        }
        this.util.get(this.api.current_add_result + '?dataForm=' + JSON.stringify(this.dataForm), '', (success) => {
          this.$router.push({path: '/currentResult/' + this.did})
        })
      }
    }
  },
  mounted () {
    this.getCurrentQuestionList()
  },
  components: {
    Btn
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .currentSubject {
    padding: pxToRem(10px);

    .currentSubject_header {
      margin-bottom: pxToRem(40px);

      .currentSubject_header_left {
        display: flex;
        padding-left: pxToRem(10px);
        width: pxToRem(120px);
        height: pxToRem(88px);
        line-height: pxToRem(88px);
      }
    }

    .currentSubject_main {
      padding: 0 pxToRem(30px);

      .currentSubject_main_top {
        background-color: #fff;
        padding: pxToRem(20px) pxToRem(30px);
        border-radius: pxToRem(30px);
        margin-bottom: pxToRem(40px);

        p {
          font-size: pxToRem(20px);

          &.currentSubject_main_title {
            color: #040404;
            font-size: pxToRem(30px);
            font-weight: bold;
            margin-bottom: pxToRem(20px);
          }
        }
      }

      .currentSubject_main_bottom {
        background-color: #fff;
        padding: pxToRem(30px) pxToRem(30px);
        border-radius: pxToRem(30px);

        .currentSubject_main_test {
          margin-bottom: pxToRem(30px);
          color: #040404;
          font-size: pxToRem(25px);
          font-weight: bold;

          .currentSubject_main_test_title {
            margin-bottom: pxToRem(10px);
          }

          .van-radio {
            margin-bottom: pxToRem(10px);
          }

          .van-cell {
            border: 1px solid #eee;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/current/currentSubject.vue